<template>
    <div class="vrm-filter-bar">
        <section class="vrm-filter-container bottom-padding">
            <div v-for="filter in dropdownFilter" :key="filter.id">
                <vrm-installation-overview-filter-dropdown
                    v-if="filter"
                    :filter="filter"
                    :filter-id="filter.id"
                    @clear="$emit('clear-filter-bar-values', filter.id)"
                    @apply="$emit('apply-filter')"
                ></vrm-installation-overview-filter-dropdown>
            </div>
            <!-- Make sure the buttons it's always on the right -->
            <div v-if="rest < 2 && rest !== 0" class="vrm-filter-bar-hide-mobile"></div>
            <div v-if="rest < 3 && rest !== 0" class="vrm-filter-bar-hide-mobile"></div>
            <div v-if="rest < 4 && rest !== 0"></div>
            <div class="vrm-filter-buttons-container">
                <button class="sg-btn sg-alt" @click="$emit('clear-filter-bar-values')">
                    {{ $t('tags.clear_all', { i18nFallback: 'Clear all' }) }}
                </button>
                <button id="confirm-filter" class="sg-btn sg-blue" @click="$emit('done-filter')">
                    {{ $t('tags.done', { i18nFallback: 'Done' }) }}
                </button>
            </div>
        </section>
    </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmInstallationOverviewFilterDropdown from '@/vue/components/shared/VrmInstallationOverviewFilterDropdown.vue';

@Component({
    components: { VrmInstallationOverviewFilterDropdown },
})
@AngularDirective('vrm-filter-bar')
@AngularLocaleBundle('tags')
export default class VrmFilterBar extends Vue {
    @Prop({ required: true })
    dropdownFilter;
    @Prop()
    beforeRender;

    rest = 0;
    mounted() {
        this.beforeRender && this.beforeRender();
        this.rest = (this.dropdownFilter.length + 1) % 4;
    }
}
</script>
